import React from 'react';

const FoodItem = ({ name, price, description, image, theme, available }) => {
    const isSoldOut = available === false; 

    return (
        <div 
            className="animate-m3-entry"
            style={{
                backgroundColor: '#fff',
                borderRadius: '24px', // M3 Large Rounded
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all 0.3s cubic-bezier(0.2, 0, 0, 1)',
                border: '1px solid #f0f0f0',
                position: 'relative',
                opacity: isSoldOut ? 0.7 : 1,
                filter: isSoldOut ? 'grayscale(0.4)' : 'none'
            }}
        >
            {isSoldOut && (
                <div style={{
                    position: 'absolute', top: '12px', left: '12px',
                    backgroundColor: 'rgba(29, 27, 32, 0.8)', // M3 On-Surface
                    color: '#fff', padding: '6px 12px', borderRadius: '100px',
                    fontSize: '0.7rem', fontWeight: '600', zIndex: 2,
                    textTransform: 'uppercase', letterSpacing: '0.5px'
                }}>
                    Sold Out
                </div>
            )}

            {image && (
                <div style={{ height: '180px', width: '100%', position: 'relative', overflow: 'hidden' }}>
                    <img
                        src={image}
                        alt={name}
                        style={{ 
                            width: '100%', height: '100%', objectFit: 'cover',
                            filter: isSoldOut ? 'brightness(0.7)' : 'none' 
                        }}
                    />
                </div>
            )}

            <div style={{ padding: '20px', flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ 
                        margin: 0, fontSize: '1.1rem', fontWeight: '600', 
                        color: isSoldOut ? '#888' : '#1D1B20' 
                    }}>
                        {name}
                    </h3>
                    <span style={{ 
                        color: isSoldOut ? '#aaa' : theme.primary, 
                        fontWeight: '700', fontSize: '1.1rem' 
                    }}>
                        ${price}
                    </span>
                </div>
                <p style={{ 
                    color: isSoldOut ? '#bbb' : '#49454F', 
                    fontSize: '0.85rem', marginTop: '10px', lineHeight: '1.5' 
                }}>
                    {description}
                </p>
            </div>
        </div>
    );
};

const DispMenu = ({ menulist, theme }) => {
    // 1. Handle Empty Menu State
    if (!menulist || menulist.length === 0) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '60px 20px',
                textAlign: 'center',
                backgroundColor: '#fff',
                borderRadius: '28px',
                margin: '20px 0',
                border: '1px dashed #ccc'
            }}>
                <div style={{ fontSize: '50px', marginBottom: '20px' }}>🍽️</div>
                <h3 style={{ color: '#1D1B20', margin: '0 0 10px 0' }}>No items available</h3>
                <p style={{ color: '#49454F', maxWidth: '300px', margin: 0, fontSize: '0.9rem' }}>
                    We couldn't find any items in this category. Please try selecting a different one!
                </p>
            </div>
        );
    }

    // 2. Normal Menu Grid
    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '24px',
            paddingBottom: '50px'
        }}>
            {menulist.map(item => (
                <FoodItem
                    key={item._id}
                    name={item.item}
                    price={item.price}
                    description={item.description}
                    image={item.image}
                    theme={theme}
                    available={item.available} 
                />
            ))}
        </div>
    );
};

export default DispMenu;